module.exports = __webpack_public_path__ + "img/04_kii_04.82484d90.jpg";